
import { computed, defineComponent, onMounted } from 'vue';
import { useDialogWithRouter } from '@/compositions/useDialogWithRouter';
import PointTransferObtain from '@/components/organisms/point/PointTransferObtain.vue';
import PointTransferExchange from '@/components/organisms/point/PointTransferExchange.vue';
import PointTransferExpire from '@/components/organisms/point/PointTransferExpire.vue';
import PointTransferConsume from '@/components/organisms/point/PointTransferConsume.vue';
import { datetimeFormat } from '@/utils';
import { useRouter } from 'vue-router/composables';

export default defineComponent({
  name: 'DialogPointHistoryDetail',

  props: {
    pointTransfer: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const router = useRouter();
    const { dialog, open, close, afterClose } = useDialogWithRouter(router);

    const actionType = computed((): string | null => {
      try {
        return JSON.parse(props.pointTransfer?.purpose).action || null;
      } catch {
        return null;
      }
    });

    const pointTransferDetailComponent = computed(() => {
      switch (actionType.value) {
        case 'grant': // 付与
          return PointTransferObtain;
        case 'exchange': // 交換
          return PointTransferExchange;
        case 'expire': // 失効
          return PointTransferExpire;
        case 'consume': // 消費
          return PointTransferConsume;
        case 'registration_incentive': // 登録
          return PointTransferObtain;
        default:
          return null;
      }
    });

    onMounted(() => {
      open();
    });

    return {
      // dialog
      dialog,
      close,
      afterClose: () => {
        afterClose();
        emit('close');
      },

      pointTransferDetailComponent,
      datetimeFormat,
    };
  },
});
